//Timing
const en = {
    postedToday: 'Posted today',
    postedYesterday: 'Posted yesterday',
    posted: 'Posted',

    free: 'Free',
}

const rus = {
    postedToday: 'Добавлено сегодня',
    postedYesterday: 'Добавлено вчера',
    posted: 'Добавлено',

    free: 'Бесплатно',
}

const hebrew = {
    postedToday: 'פורסם היום',
    postedYesterday: 'פורסם אתמול',
    posted: 'פורסם',

    free: 'חינם',
}

const choose = { en, rus, hebrew };

export default choose;